import ScreenLoader from '../views/ScreenLoader.js';
window.loadingScreen = new ScreenLoader (.35,.65);
import { gsap } from 'gsap';


window.barbaDefaultTransition = {
  sync: false,
  name: 'loadingScreen',
  before: function(data) {
    console.log('HELO BEFORE',data.next)
    var  done = this.async();
    
    
    window.menuNav.hide().then(function(){

      window.loadingScreen.show().then(function(res){
        $('canvas').removeClass("z-index-fixer")
        done()
        appEvent.trigger('app:barba:beforeDone');
  
      });
    })
    
  },
  beforeLeave: function(data){
    console.log('HELO LEAVE',data.next)

    
  },
  afterLeave: function(data){

  },
  beforeEnter: function(data) {
    appEvent.trigger('app:barba:beforeEnter');
    var  done = this.async();
    window.imageLoader.load(data.next.container, function(){
      if (data.next.namespace == "homeIndex" && window.scene){
        gsap.to('.webgl-overlay',{
          duration:1,
          autoAlpha:1,
          ease:"power2.inOut",
          onComplete:()=>{
            done()
          }
        })
      }else{
        done()
      }

    });
  },
  enter: function(data){
    if (data.next.namespace != "homeIndex" && window.scene){
      gsap.to('.webgl-overlay',{
        duration:1,
        autoAlpha: 0,
        ease:"power2.inOut",
      })
    }
    window.loadingScreen.hide().then(function(){

    })
  }

};
